<div class="modal-window__header">
  <div class="modal-window__title">
    {{ (newReminder ? "reminder.createtitle" : "reminder.edittitle") | translate }}
  </div>
  <a (click)="onCancel()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="onSave()"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label class="c-form-label">
      {{ "reminder.type" | translate }}
      <app-loading-icon
        *ngIf="isTypesLoading"
        class="u-color--light"></app-loading-icon>
    </label>
    <mat-select
      #type="ngModel"
      [(ngModel)]="reminder.type"
      name="type"
      id="type"
      class="c-select c-select--lg"
      [class.is-invalid]="(type.touched && type.invalid) || reminderAlreadyExists"
      (ngModelChange)="onReminderTypeChange()"
      [disabled]="!newReminder || isLoading"
      required>
      <mat-option
        [value]="t.key"
        *ngFor="let t of reminderService.types">
        {{ t.title | translate }}
      </mat-option>
    </mat-select>
    <div
      *ngIf="type.touched && type.invalid"
      class="c-form-alert">
      {{ "reminder.typerequirederror" | translate }}
    </div>
    <div
      *ngIf="reminderAlreadyExists"
      class="c-form-alert">
      {{ "reminder.alreadycreatederror" | translate }}
    </div>
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label class="c-form-label"> {{ "reminder.interval" | translate }}</label>
    <mat-select
      #interval="ngModel"
      [(ngModel)]="reminder.interval"
      name="interval"
      id="interval"
      class="c-select c-select--lg"
      [class.is-invalid]="interval.touched && interval.invalid"
      required>
      <mat-option
        [value]="i.key"
        *ngFor="let i of reminderService.intervals">
        {{ i.title | translate }}
      </mat-option>
    </mat-select>
    <div
      *ngIf="interval.touched && interval.invalid"
      class="c-form-alert">
      {{ "reminder.intervalrequirederror" | translate }}
    </div>
  </div>
  <div
    *ngIf="!isNotification(reminder)"
    class="c-form-group o-grid__item col-12 col-sm-12">
    <label class="c-form-label">{{
      (isPO(reminder) ? "reminder.daysafter" : "reminder.daysbefore") | translate
    }}</label>
    <mat-select
      #days="ngModel"
      [(ngModel)]="reminder.daysInAdvance"
      name="days"
      id="days"
      type="number"
      class="c-select c-select--lg"
      [class.is-invalid]="days.touched && days.invalid"
      required>
      <mat-option
        [value]="d"
        *ngFor="let d of daysList">
        {{ d }}
      </mat-option>
    </mat-select>
    <div
      *ngIf="days.touched && days.invalid"
      class="c-form-alert">
      {{
        (isPO(reminder) ? "reminder.daysafterrequirederror" : "reminder.daysbeforrequirederror")
          | translate
      }}
    </div>
  </div>
  <div
    *ngIf="reminder?.type && !isPO(reminder)"
    class="c-form-group o-grid__item col-12 col-sm-12 center">
    <label
      for="toRecipients"
      class="c-form-label">
      {{ "reminder.to" | translate }}</label
    >
    <email-select
      [valid]="!!reminder.to"
      [reminder]="reminder"
      [selectedItems]="reminder.to"
      (selectionChange)="reminder.to = $event"
      required>
    </email-select>
    <div
      *ngIf="!reminder.to"
      class="c-form-alert">
      {{ "reminder.fieldrequirederror" | translate }}
    </div>
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12 center">
    <label
      for="ccRecipients"
      class="c-form-label">
      {{ "reminder.cc" | translate }}</label
    >
    <email-select
      [reminder]="reminder"
      [selectedItems]="reminder.cc"
      [skipItemsLoad]="true"
      (selectionChange)="reminder.cc = $event">
    </email-select>
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12 center">
    <label
      for="bccRecipients"
      class="c-form-label">
      {{ "reminder.bcc" | translate }}</label
    >
    <email-select
      [reminder]="reminder"
      [selectedItems]="reminder.bcc"
      [skipItemsLoad]="true"
      (selectionChange)="reminder.bcc = $event">
    </email-select>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="onCancel()">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="
        f.invalid || isLoading || reminderAlreadyExists || (!isPO(reminder) && !reminder.to)
      ">
      <app-loading-icon *ngIf="isLoading"></app-loading-icon>
      <span *ngIf="!isLoading"> {{ "button.save" | translate }}</span>
    </button>
  </div>
</form>
